import { render, staticRenderFns } from "./ReviewModalContent.vue?vue&type=template&id=5a31a496&"
import script from "./ReviewModalContent.vue?vue&type=script&lang=js&"
export * from "./ReviewModalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiReadMoreClamp: require('/app/components/UI/UiReadMoreClamp.vue').default})
